module.exports = __webpack_public_path__ + "static/media/OffHand_1.8907bb14.jpg";